import React from "react";
import RadioFilledIcon from "assets/svgs/radio_filled.svg";
import FileSvg from "assets/svgs/file_copy.svg";
import popupcrossbutton from "assets/images/popupcrossbutton.png";
import deleteForever from "assets/images/delete_forever.png";
import { Icons } from "components/core";
import { Ptag } from "components/core/fonts";
import {
  BorderDiv,
  ImageDiv,
  MainDiv,
  MiddleSection,
  LongLine,
} from "./styles";

const UploadedFileName = ({ file, onClick }) => {
  const fileSize = Math.floor(file.size / 1000);
  //   console.log(file, onClick);
  //   onClick(true)
  const exit = () => {
    onClick && onClick(true);
  };
  return (
    <MainDiv>
      <BorderDiv>
        <ImageDiv src={FileSvg} />
      </BorderDiv>
      <MiddleSection>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Ptag
            fontSize="14px"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "90%",
            }}
          >
            {file.name}
          </Ptag>
          <img
            src={RadioFilledIcon}
            style={{ height: "14px", width: "14px" }}
          />
        </div>
        <Ptag>{fileSize}kb</Ptag>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <LongLine></LongLine>
          <Ptag>100%</Ptag>
        </div>
      </MiddleSection>
      <img
        style={{ cursor: "pointer" }}
        src={deleteForever}
        onClick={exit}
        width="14px"
        height="14px"
      />
      {/* <Icons
        style={{ position: "absolute", marginLeft: "74%" }}
        icon="roundCross"
        fill="blue"
        height="14px"
        width="14px"
        // onClick={onClick()}
      /> */}
    </MainDiv>
  );
};
export default UploadedFileName;
